import React from "react";

const WishlistHeart: React.FC<{color?: string; filled: boolean; size?: number}> = ({
  color = "#1ba1e2",
  filled,
  size = 28,
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={`${size}px`} height={`${size}px`} viewBox="0 0 478 423">
    <g fill={filled ? color : "none"}>
      <path
        d="M432 46h0a124 124 0 00-175 0l-18 18-18-18a124 124 0 00-175 0h0a124 124 0 000 175l192 192a2 2 0 002 0l192-192a124 124 0 000-175z"
        stroke={color}
        strokeMiterlimit="15"
        strokeWidth="20"
      />
      <path d="M432 46a124 124 0 00-175 0l-18 18-18-18a124 124 0 00-175 0 124 124 0 000 175l192 192a2 2 0 002 0l192-192a124 124 0 000-175z" />
    </g>
  </svg>
);

export default WishlistHeart;
